import React from 'react' 
import "../common/header/header.css"; 
import "../common/style.css"; 
import 'moment-timezone'; 
import "bootstrap/dist/js/bootstrap"; 
import "bootstrap/dist/css/bootstrap.min.css"; 
import "bootstrap/js/src/dropdown"; 
import "../App.css";  
import _ from "lodash"; 
import NotificationAPI from "../common/util/NotificationAPI"; 
import { Modal as AntdModal,Menu,Dropdown as AntDropDown,Switch as AntSwitch} from "antd"; 
import SettingIcon from '../assets/images/svg/SettingIcon.svg';
import { CheckOutlined, CloseOutlined, LeftOutlined } from "@ant-design/icons";  
const { SubMenu } = Menu;
export default function SettingPopoverWrapper({handleSettingChange,notificationFilter, notificationCacheList, notifyTabKey, getNotification }) {
    const [loader, setLoader] = React.useState(false);
    function getCollapseOptions(){
      return <div className="Module-Selection-Wrapper Do-Not-Close" onClick={e=>{
        e.stopPropagation();
        e.preventDefault();
      }}>
        {/* <div className="Module-Selection-Header">Notification Control</div> */}
        {notificationFilter && notificationFilter.map((m,i)=>{
          return (<div className="Module-Wrapper">
          <span style={{marginRight: "5px"}}>{m.name}</span>
          <div>
          <AntSwitch size="default" 
           checkedChildren={<CheckOutlined />}
           unCheckedChildren={<CloseOutlined />}
          defaultChecked checked={m.settingObj?.active?m.settingObj?.active:false} 
          onClick={e=>handleSettingChange(e,"NotificationFilter",i)} />
            {/* <input checked={m.settingObj?.active?m.settingObj?.active:false} type="checkbox" 
            onClick={e=>handleSettingChange(e,"NotificationFilter",i)} /> */}
          </div>
        </div>)
        })}
      </div>
    }
    function getSettingPopOver(){
      const menu = (
        <Menu>
          <Menu.Item key="0" icon={<> </>}
            onClick={async (e) => { 
              setLoader(true);
              let list = [...notificationCacheList];
              // list = list.filter(one => !one.Notifications.IsArchive);
              let doArr = [];
              list.forEach((one) => {
                if (notifyTabKey == "Unarchive") {
                  one.IsArchive = true;
                }
                if (notifyTabKey == "Archive") {
                  one.IsArchive = false;
                }
                doArr.push(
                  NotificationAPI.UpdateNotification(one)
                );
              });
              await Promise.all(doArr)
                .then((result) => {
                  getNotification();
                  setLoader(false);
                })
                .catch((err) => {
                  console.error(err);
                  setLoader(false);
                });
            }}
          >{notifyTabKey == "Unarchive"? " Archive All": "Active All"}</Menu.Item>
          <Menu.Item key="1" icon={<> </>} onClick={(e) => {
            // e.preventDefault()
            // e.stopPropagation();
            setLoader(true);
            let list = [...notificationCacheList];
            list = list.filter(
              (one) => !one.IsRead
            );
            let doArr = [];
            list.forEach((one) => {
              one.IsRead = true;
              doArr.push(
                NotificationAPI.UpdateNotification(
                  one
                )
              );
            });
            Promise.all(doArr)
              .then((result) => {
                getNotification();
                setLoader(false);
              })
              .catch((err) => {
                console.error(err);
                setLoader(false);
              });
          }}>Mark all as read</Menu.Item>
          <SubMenu key="sub1" icon={<LeftOutlined className="submenu-arrow" />} title={"Notification Control"}>
            {getCollapseOptions()}
          </SubMenu>
        </Menu>
      );
      return <>
        <AntDropDown
          style={{ color: "none" }}
          className="Notification-Setting-Icon"
          overlayClassName="Notification-Setting-Popover Do-Not-Close"
          // arrow={true}
          overlay={menu}
          // menu={{
          //   items,
          // }}
          trigger={["click"]}
        >
          <img style={{ height: "1rem" }} src={SettingIcon} />
        </AntDropDown>
      </>
    }
    return (<>
    {getSettingPopOver()}
    </>)
}
